document.addEventListener('DOMContentLoaded', () => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isCoarsePointer = window.matchMedia('(pointer: coarse)').matches;

  initReveal();
  initMagnetic();

  function initReveal() {
    const items = document.querySelectorAll('[data-v-reveal]');
    if (!items.length) return;

    if (reduceMotion) {
      items.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -5% 0px' }
    );

    items.forEach((el) => observer.observe(el));
  }

  function initMagnetic() {
    if (isCoarsePointer) return;
    const buttons = document.querySelectorAll('[data-magnetic]');
    if (!buttons.length) return;

    const strength = 0.3;
    const radius = 80;

    buttons.forEach((btn) => {
      const onMove = (event) => {
        const rect = btn.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;
        const dx = event.clientX - centerX;
        const dy = event.clientY - centerY;
        const distance = Math.hypot(dx, dy);

        if (distance < radius) {
          btn.style.transition = 'transform 0.1s ease-out';
          btn.style.transform = `translate(${dx * strength}px, ${dy * strength}px)`;
        } else {
          btn.style.transition = 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)';
          btn.style.transform = 'translate(0, 0)';
        }
      };

      document.addEventListener('mousemove', onMove);
      btn.addEventListener('mouseleave', () => {
        btn.style.transition = 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)';
        btn.style.transform = 'translate(0, 0)';
      });
    });
  }
});
